import React, { useEffect, useState, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, checkAuth } = useAuth();
  const location = useLocation();
  const [authChecked, setAuthChecked] = useState(false);
  const checkingRef = useRef(false);
  
  useEffect(() => {
    const verifyAuth = async () => {
      if (user || checkingRef.current) {
        setAuthChecked(true);
        return;
      }
      
      checkingRef.current = true;
      await checkAuth();
      setAuthChecked(true);
      checkingRef.current = false;
    };
    
    verifyAuth();
  }, [user, checkAuth]);
  
  if (!authChecked || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="text-neutral-600">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return React.cloneElement(children, { user });
};

export default ProtectedRoute;
